import React from 'react';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-4xl font-bold mb-4">404 - Not Found</h1>
      <p className="text-lg text-gray-600 mb-4">The page you are looking for might be under construction or does not exist.</p>
      <a href="/" className="text-blue-500 hover:underline">Go to Home Page</a>
    </div>
  );
};

export default NotFound;
